export var extractDownloadUrl = function extractDownloadUrl(jsonLd) {
  if (jsonLd['atlassian:downloadUrl']) {
    return jsonLd['atlassian:downloadUrl'];
  }
};